import { useEffect, useState } from "react";
import Navbar from "./Navbar";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Slide } from 'react-toastify';
import { useOktaAuth } from "@okta/okta-react";
import { oktaAuth } from "../config";
import Service from "../services/Service";
import Modal from 'react-modal';
import { customStylesModal } from '../global';

const largeModalStyles = {
    content: {
        "z-index": 6,
        top: '5%',
        right: '4vw',
        left: 'auto',
        bottom: 'auto',
        width: window.innerWidth > 1000 ? '550px' : '90%',
        height: 'min-content',
        maxHeight: '85vh',
        backgroundColor: 'white',
        overflow: 'auto',
    }
};

export default function UsersPage(props) {
    const [loading, setLoading] = useState(false);
    const { authState } = useOktaAuth();
    const [auth, setAuth] = useState(null)
    const [user, setUser] = useState(null)
    const [users, setUsers] = useState([])
    const [totalRecords, setTotalRecords] = useState(0)
    const [pageNumber, setPageNumber] = useState(1)
    const [pageSize] = useState(20)
    const [confirmDialog, setConfirmDialog] = useState(false)
    const [userToDelete, setUserToDelete] = useState(null)
    const [storesModal, setStoresModal] = useState(false)
    const [storesUser, setStoresUser] = useState(null)
    const [userStores, setUserStores] = useState([])
    const [newStoreJDA, setNewStoreJDA] = useState('')
    const [storesLoading, setStoresLoading] = useState(false)
    // Filters
    const [filterEmail, setFilterEmail] = useState('')
    const [filterRole, setFilterRole] = useState('')
    const [filterStore, setFilterStore] = useState('')
    // Edit user
    const [editIsAdmin, setEditIsAdmin] = useState(false)
    const [editVisType, setEditVisType] = useState('')
    const [editZone, setEditZone] = useState('')
    const [editCountries, setEditCountries] = useState([])
    const [editCountrySearch, setEditCountrySearch] = useState('')
    const [editCluster, setEditCluster] = useState('')
    const [editJDA, setEditJDA] = useState('')
    const [savingVis, setSavingVis] = useState(false)
    // Create user modal
    const [createModal, setCreateModal] = useState(false)
    const [newUserEmail, setNewUserEmail] = useState('')
    const [newUserIsAdmin, setNewUserIsAdmin] = useState(false)
    const [visibilityType, setVisibilityType] = useState('jda')
    const [newUserZone, setNewUserZone] = useState('')
    const [newUserCountries, setNewUserCountries] = useState([])
    const [newUserCountrySearch, setNewUserCountrySearch] = useState('')
    const [newUserJDAs, setNewUserJDAs] = useState([])
    const [newUserStoreSearch, setNewUserStoreSearch] = useState('')
    const [emailExists, setEmailExists] = useState(false)
    const [checkingEmail, setCheckingEmail] = useState(false)
    const [creating, setCreating] = useState(false)
    // Lookups
    const [zones, setZones] = useState([])
    const [countries, setCountries] = useState([])
    const [clusters, setClusters] = useState([])
    const [allStores, setAllStores] = useState([])
    const [storeSearch, setStoreSearch] = useState('')

    const loggingIn = async () => oktaAuth.signInWithRedirect({ originalUri: "/" });
    const service = new Service()

    useEffect(() => {
        let clear_url = window.location.href.split('/login')[0]
        if (clear_url)
            window.history.replaceState({ page: "display_page" }, "display_page", clear_url);
        if (localStorage.getItem('okta-token-storage') && JSON.parse(localStorage.getItem('okta-token-storage')).accessToken && JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken) {
            setAuth('OK')
            service.getUser().then((data) => {
                setUser(data)
            }).catch((error) => {
                if (error.response.status == 401) {
                    if (error.response.data.code === "unauthorized") {
                        setAuth('notauth')
                    }
                    else if (error?.response?.data?.code === "missing_token") {
                        Promise.resolve(loggingIn())
                    }
                    else if (error.response.data.code === "expired_token") {
                        localStorage.setItem('refresh', true)
                        window.location.reload()
                    }
                }
            })
        }
        else if (!authState?.isAuthenticated) {
            if (!window.location.href.includes('code') && window.location.pathname && window.location.pathname.split('/').length > 0) {
                Promise.resolve(loggingIn())
            } else {
                setAuth('noauth')
            }
        }
    }, [])

    useEffect(() => {
        if (!user || !user.is_super_admin) return
        const timer = setTimeout(loadUsers, 400)
        return () => clearTimeout(timer)
    }, [user, pageNumber, filterEmail, filterRole, filterStore])

    const loadUsers = () => {
        setLoading(true)
        service.getUsersList(pageNumber, pageSize, filterEmail, filterRole, filterStore).then((data) => {
            setUsers(data.users || data.Users || [])
            setTotalRecords(data.totalRecords || data.TotalRecords || 0)
            setLoading(false)
        }).catch((err) => {
            setLoading(false)
            toast.error(err.response?.data?.message || err.message || 'Error loading users', {
                transition: Slide,
                toastId: 'users_error'
            })
        })
    }

    const deleteUserConfirm = (userEmail) => {
        setUserToDelete(userEmail)
        setConfirmDialog(true)
    }

    const deleteUser = () => {
        if (!userToDelete) return
        service.deleteUser(userToDelete).then((response) => {
            setConfirmDialog(false)
            setUserToDelete(null)
            toast.success(response.message || 'User deleted successfully', { transition: Slide })
            loadUsers()
        }).catch((err) => {
            setConfirmDialog(false)
            toast.error(err.response?.data?.message || err.message || 'Error deleting user', {
                transition: Slide,
                toastId: 'delete_error'
            })
        })
    }

    const toggleAdmin = (userEmail, currentIsAdmin) => {
        const newIsAdmin = !currentIsAdmin
        service.setUserAdmin(userEmail, newIsAdmin).then((response) => {
            toast.success(response.message || (newIsAdmin ? 'User promoted to admin' : 'User demoted from admin'), { transition: Slide })
            loadUsers()
        }).catch((err) => {
            toast.error(err.response?.data?.message || err.message || 'Error updating admin role', {
                transition: Slide,
                toastId: 'admin_error'
            })
        })
    }

    const openStoresModal = (userEmail) => {
        setStoresUser(userEmail)
        setStoresModal(true)
        setStoresLoading(true)
        setNewStoreJDA('')
        setSavingVis(false)
        // Find current user from users list
        const u = users.find(x => (x.email || x.Email) === userEmail)
        if (u) {
            setEditIsAdmin(!!(u.is_admin || u.isAdmin || u.IsAdmin))
            const zone = u.zone || u.Zone || ''
            const country = u.country || u.Country || ''
            const cluster = u.cluster || u.Cluster || ''
            const jda = u.jda || u.JDA || ''
            setEditCountrySearch('')
            if (zone) { setEditVisType('zone'); setEditZone(zone); setEditCountries([]); setEditCluster(''); setEditJDA('') }
            else if (country) { setEditVisType('country'); setEditCountries(country.split('|').map(c => c.trim()).filter(c => c)); setEditZone(''); setEditCluster(''); setEditJDA('') }
            else if (jda) { setEditVisType('jda'); setEditJDA(jda); setEditCluster(cluster); setEditZone(''); setEditCountries([]) }
            else { setEditVisType('all'); setEditZone(''); setEditCountries([]); setEditCluster(''); setEditJDA('') }
        }
        // Load lookups
        service.getLookups().then((data) => {
            setZones(data.zones || [])
            setCountries(data.countries || [])
            setClusters(data.clusters || [])
            setAllStores(data.stores || [])
        }).catch(() => { })
        // Load stores from API, fallback to raw JDA split
        service.getUserStores(userEmail).then((data) => {
            if (data && data.length > 0) {
                setUserStores(data)
            } else {
                // Fallback: parse JDA pipe string from users list
                const u2 = users.find(x => (x.email || x.Email) === userEmail)
                const rawJda = u2 ? (u2.jda || u2.JDA || '') : ''
                if (rawJda) {
                    const jdaList = rawJda.split('|').filter(j => j.trim()).map(j => ({ location_code: j.trim(), location_description: '-', Country: '-' }))
                    setUserStores(jdaList)
                } else {
                    setUserStores([])
                }
            }
            setStoresLoading(false)
        }).catch((err) => {
            setStoresLoading(false)
            toast.error(err.response?.data?.message || err.message || 'Error loading stores', {
                transition: Slide,
                toastId: 'stores_error'
            })
        })
    }

    const reloadStores = () => {
        service.getUserStores(storesUser).then((data) => {
            setUserStores(data && data.length > 0 ? data : [])
        }).catch(() => { setUserStores([]) })
        loadUsers()
    }

    const addStore = () => {
        if (!newStoreJDA.trim() || !storesUser) return
        service.addUserVisibility(storesUser, newStoreJDA.trim()).then((response) => {
            toast.success(response.message || 'Store added successfully', { transition: Slide })
            setNewStoreJDA('')
            setStoreSearch('')
            reloadStores()
        }).catch((err) => {
            toast.error(err.response?.data?.message || err.message || 'Error adding store', {
                transition: Slide,
                toastId: 'add_store_error'
            })
        })
    }

    const removeStore = (jda) => {
        if (!storesUser) return
        service.removeUserVisibility(storesUser, jda).then((response) => {
            toast.success(response.message || 'Store removed successfully', { transition: Slide })
            reloadStores()
        }).catch((err) => {
            toast.error(err.response?.data?.message || err.message || 'Error removing store', {
                transition: Slide,
                toastId: 'remove_store_error'
            })
        })
    }

    const saveVisibility = () => {
        const data = { email: storesUser, visibilityType: editVisType }
        if (editVisType === 'zone') {
            if (!editZone) { toast.error('Please select a zone', { transition: Slide, toastId: 'vis_err' }); return }
            data.zone = editZone
        } else if (editVisType === 'country') {
            if (!editCountries || editCountries.length === 0) { toast.error('Please select at least one country', { transition: Slide, toastId: 'vis_err' }); return }
            data.country = editCountries.join('|')
        } else if (editVisType === 'jda') {
            data.jda = editJDA
            if (editCluster) data.cluster = editCluster
        }
        setSavingVis(true)
        service.updateUserVisibility(data).then((response) => {
            setSavingVis(false)
            toast.success(response.message || 'Visibility updated', { transition: Slide })
            setStoresModal(false)
            loadUsers()
        }).catch((err) => {
            setSavingVis(false)
            toast.error(err.response?.data?.message || err.message || 'Error updating visibility', {
                transition: Slide, toastId: 'vis_error'
            })
        })
    }

    // Create user
    const openCreateModal = () => {
        setCreateModal(true)
        setNewUserEmail('')
        setNewUserIsAdmin(false)
        setVisibilityType('jda')
        setNewUserZone('')
        setNewUserCountries([])
        setNewUserCountrySearch('')
        setNewUserJDAs([])
        setNewUserStoreSearch('')
        setEmailExists(false)
        setCreating(false)
        // Load lookups
        service.getLookups().then((data) => {
            setZones(data.zones || [])
            setCountries(data.countries || [])
            setClusters(data.clusters || [])
            setAllStores(data.stores || [])
        }).catch(() => { })
    }

    const checkEmail = (email) => {
        setNewUserEmail(email)
        setEmailExists(false)
        if (email && email.includes('@')) {
            setCheckingEmail(true)
            service.checkUserExists(email).then((data) => {
                setEmailExists(data.exists)
                setCheckingEmail(false)
            }).catch(() => { setCheckingEmail(false) })
        }
    }

    const createUser = () => {
        if (!newUserEmail || !newUserEmail.includes('@')) {
            toast.error('Please enter a valid email', { transition: Slide, toastId: 'create_err' })
            return
        }
        if (emailExists) {
            toast.error('This email already exists', { transition: Slide, toastId: 'create_err' })
            return
        }
        const data = {
            email: newUserEmail,
            isAdmin: newUserIsAdmin,
            visibilityType: visibilityType
        }
        if (visibilityType === 'zone') {
            if (!newUserZone) { toast.error('Please select a zone', { transition: Slide, toastId: 'create_err' }); return }
            data.zone = newUserZone
        } else if (visibilityType === 'country') {
            if (!newUserCountries || newUserCountries.length === 0) { toast.error('Please select at least one country', { transition: Slide, toastId: 'create_err' }); return }
            data.country = newUserCountries.join('|')
        } else if (visibilityType === 'jda') {
            if (!newUserJDAs || newUserJDAs.length === 0) { toast.error('Please select at least one JDA', { transition: Slide, toastId: 'create_err' }); return }
            data.jda = newUserJDAs.map(s => s.jda).join('|')
            const firstCluster = newUserJDAs[0].cluster
            if (firstCluster) data.cluster = firstCluster
        }
        setCreating(true)
        service.createUser(data).then((response) => {
            toast.success(response.message || 'User created successfully', { transition: Slide })
            setCreateModal(false)
            setCreating(false)
            loadUsers()
        }).catch((err) => {
            setCreating(false)
            toast.error(err.response?.data?.message || err.message || 'Error creating user', {
                transition: Slide,
                toastId: 'create_error'
            })
        })
    }

    // Export
    const exportExcel = () => {
        service.exportUsers(filterEmail, filterRole, filterStore).then((blob) => {
            const url = window.URL.createObjectURL(new Blob([blob]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'users_export.xlsx')
            document.body.appendChild(link)
            link.click()
            link.remove()
        }).catch((err) => {
            toast.error('Error exporting users', { transition: Slide, toastId: 'export_err' })
        })
    }

    const resetFilters = () => {
        setFilterEmail('')
        setFilterRole('')
        setFilterStore('')
        setPageNumber(1)
    }

    const totalPages = Math.ceil(totalRecords / pageSize)

    const formatDateTime = (dateString) => {
        if (!dateString) return '-'
        const date = new Date(dateString)
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    }

    const getVisibility = (u) => {
        const zone = u.zone || u.Zone || ''
        const country = u.country || u.Country || ''
        const jda = u.jda || u.JDA || ''
        if (zone) return `Zone: ${zone}`
        if (country) {
            const list = country.split('|').filter(c => c.trim())
            return list.length > 1 ? `Country (${list.length})` : `Country: ${list[0]}`
        }
        if (jda) {
            const count = jda.split('|').filter(j => j.trim()).length
            return `JDA (${count})`
        }
        return 'All'
    }

    const inputStyle = 'padding: 6px 10px; border: 1px solid #b6b6b6; border-radius: 5px; font-size: 13px;'

    return (
        (loading ? '' : auth ? (auth == 'notauth' ? <div>
            <Navbar />
            <div Style={' height: calc(100vh - 70px);align-content: center;'}>
                <div className='label_text_bold center ' Style={'font-size:22px'}>Not authorized</div>
            </div>
        </div>
            :
            user && user.is_super_admin ?
                <div>
                    <Navbar />
                    <div className="flex subheader">
                        <div Style={'width:100%; padding: 20px; display: flex; justify-content: space-between; align-items: center;'}>
                            <div className='label_text_bold' Style={'font-size:22px;'}>User Management</div>
                            <div Style={'display: flex; gap: 10px;'}>
                                <button className='submit-button' onClick={openCreateModal} Style={'font-size: 13px; padding: 8px 16px;'}>
                                    + New User
                                </button>
                                <button className='cancel-button' onClick={exportExcel} Style={'font-size: 13px; padding: 8px 16px;'}>
                                    Export Excel
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* Filters */}
                    <div Style={'padding: 0 20px; display: flex; gap: 10px; align-items: center; flex-wrap: wrap; margin-bottom: 10px;'}>
                        <input
                            type="text"
                            value={filterEmail}
                            onChange={(e) => { setFilterEmail(e.target.value); setPageNumber(1) }}
                            placeholder="Filter by email..."
                            Style={inputStyle + ' flex: 1; min-width: 200px;'}
                        />
                        <select
                            value={filterRole}
                            onChange={(e) => { setFilterRole(e.target.value); setPageNumber(1) }}
                            Style={inputStyle + ' min-width: 140px;'}
                        >
                            <option value="">All roles</option>
                            <option value="admin">Admin</option>
                            <option value="superadmin">Super Admin</option>
                            <option value="user">User</option>
                        </select>
                        <input
                            type="text"
                            value={filterStore}
                            onChange={(e) => { setFilterStore(e.target.value); setPageNumber(1) }}
                            placeholder="Filter by JDA..."
                            Style={inputStyle + ' min-width: 120px;'}
                        />
                        {(filterEmail || filterRole || filterStore) &&
                            <button className='cancel-button' onClick={resetFilters} Style={'font-size: 12px; padding: 6px 12px;'}>
                                Clear
                            </button>
                        }
                    </div>
                    {!loading ?
                        <div className="table-container">
                            <div className="table_container" Style={'height:calc(100vh - 280px); min-height:150px'}>
                                <table className="responsive-table mt0">
                                    <thead>
                                        <tr className="table-header">
                                            <th>Email</th>
                                            <th>Visibility</th>
                                            <th>Admin</th>
                                            <th>Last Access</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {users && users.length > 0 ? users.map((u) => (
                                            <tr key={u.email || u.Email}>
                                                <td><div className="mid">{u.email || u.Email}</div></td>
                                                <td><div className="mid">{getVisibility(u)}</div></td>
                                                <td><div className="mid">{(u.is_admin || u.isAdmin || u.IsAdmin) ? 'Yes' : 'No'}</div></td>
                                                <td><div className="mid">{formatDateTime(u.lastAccessDate || u.LastAccessDate || u.last_access_date)}</div></td>
                                                <td>
                                                    <div className="mid" Style={'display: flex; gap: 12px; align-items: center; justify-content: center;'}>
                                                        <svg
                                                            onClick={() => openStoresModal(u.email || u.Email)}
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="18"
                                                            height="18"
                                                            fill="currentColor"
                                                            className="bi bi-pencil"
                                                            viewBox="0 0 16 16"
                                                            Style={'cursor: pointer;'}
                                                        >
                                                            <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                                                        </svg>
                                                        <svg
                                                            onClick={() => deleteUserConfirm(u.email || u.Email)}
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="20"
                                                            height="20"
                                                            fill="red"
                                                            className="bi bi-trash"
                                                            viewBox="0 0 16 16"
                                                            Style={'cursor: pointer;'}
                                                        >
                                                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                        </svg>
                                                    </div>
                                                </td>
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan="5">
                                                    <div className="mid" Style={'padding: 20px;'}>No users found</div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                {totalPages > 1 && (
                                    <div Style={'display: flex; justify-content: center; align-items: center; padding: 20px; gap: 10px;'}>
                                        <button
                                            className='cancel-button'
                                            onClick={() => setPageNumber(p => Math.max(1, p - 1))}
                                            disabled={pageNumber === 1}
                                            Style={pageNumber === 1 ? 'opacity: 0.5; cursor: not-allowed;' : ''}
                                        >
                                            Previous
                                        </button>
                                        <span className='label_text'>
                                            Page {pageNumber} of {totalPages} ({totalRecords} total users)
                                        </span>
                                        <button
                                            className='submit-button'
                                            onClick={() => setPageNumber(p => Math.min(totalPages, p + 1))}
                                            disabled={pageNumber === totalPages}
                                            Style={pageNumber === totalPages ? 'opacity: 0.5; cursor: not-allowed;' : ''}
                                        >
                                            Next
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                        : <div className="loader-cont">
                            <div className="loader1"></div>
                        </div>}
                    {/* Delete Confirmation Modal */}
                    <Modal ariaHideApp={false} isOpen={confirmDialog} onRequestClose={() => setConfirmDialog(false)} style={customStylesModal}>
                        <div className='modal_filters_container'>
                            <div>
                                <div className='filter-label-cont' Style={'text-align:center'}>Are you sure</div>
                                <svg onClick={() => setConfirmDialog(false)} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-x close-button" viewBox="0 0 16 16">
                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                </svg>
                            </div>
                            <hr className='separator' />
                            <div className='label_text center'>You are about to delete the user: <strong>{userToDelete}</strong></div>
                            <div className="label_text_bold center">Do you want to proceed?</div>
                            <div className='flex_center mt-10' Style={'width:100%'}>
                                <button className='cancel-button' onClick={() => setConfirmDialog(false)}>Cancel</button>
                                <button className='submit-button' onClick={() => deleteUser()}>Delete</button>
                            </div>
                        </div>
                    </Modal>
                    {/* Edit User Modal */}
                    <Modal ariaHideApp={false} isOpen={storesModal} onRequestClose={() => setStoresModal(false)} style={largeModalStyles}>
                        <div className='modal_filters_container'>
                            <div>
                                <div className='filter-label-cont' Style={'text-align:center'}>Edit User</div>
                                <svg onClick={() => setStoresModal(false)} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-x close-button" viewBox="0 0 16 16">
                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                </svg>
                            </div>
                            <hr className='separator' />
                            {/* Email (read-only) */}
                            <div Style={'margin-bottom: 15px;'}>
                                <div className='label_text' Style={'margin-bottom: 5px; font-weight: bold;'}>Email</div>
                                <input type="text" value={storesUser || ''} readOnly
                                    Style={'width: 100%; padding: 8px 10px; border: 1px solid #b6b6b6; border-radius: 5px; box-sizing: border-box; background-color: #f0f0f0; color: #666;'} />
                            </div>
                            {/* Admin */}
                            <div Style={'margin-bottom: 15px;'}>
                                <div className='label_text' Style={'margin-bottom: 5px; font-weight: bold;'}>Admin</div>
                                <select value={editIsAdmin ? 'yes' : 'no'}
                                    onChange={(e) => { const val = e.target.value === 'yes'; toggleAdmin(storesUser, editIsAdmin); setEditIsAdmin(val) }}
                                    Style={'width: 100%; padding: 8px 10px; border: 1px solid #b6b6b6; border-radius: 5px; box-sizing: border-box;'}>
                                    <option value="no">No</option>
                                    <option value="yes">Yes</option>
                                </select>
                            </div>
                            {/* Visibility */}
                            <div Style={'margin-bottom: 15px;'}>
                                <div className='label_text' Style={'margin-bottom: 8px; font-weight: bold;'}>Visibility</div>
                                <div Style={'display: flex; gap: 15px; margin-bottom: 10px;'}>
                                    <label Style={'cursor: pointer; display: flex; align-items: center; gap: 5px;'}>
                                        <input type="radio" name="editVisType" value="zone" checked={editVisType === 'zone'}
                                            onChange={() => setEditVisType('zone')} Style={'cursor: pointer;'} />
                                        <span className='label_text'>Zone</span>
                                    </label>
                                    <label Style={'cursor: pointer; display: flex; align-items: center; gap: 5px;'}>
                                        <input type="radio" name="editVisType" value="country" checked={editVisType === 'country'}
                                            onChange={() => setEditVisType('country')} Style={'cursor: pointer;'} />
                                        <span className='label_text'>Country</span>
                                    </label>
                                    <label Style={'cursor: pointer; display: flex; align-items: center; gap: 5px;'}>
                                        <input type="radio" name="editVisType" value="jda" checked={editVisType === 'jda'}
                                            onChange={() => setEditVisType('jda')} Style={'cursor: pointer;'} />
                                        <span className='label_text'>JDA</span>
                                    </label>
                                    <label Style={'cursor: pointer; display: flex; align-items: center; gap: 5px;'}>
                                        <input type="radio" name="editVisType" value="all" checked={editVisType === 'all'}
                                            onChange={() => setEditVisType('all')} Style={'cursor: pointer;'} />
                                        <span className='label_text'>All</span>
                                    </label>
                                </div>
                                {editVisType === 'zone' && (
                                    <select value={editZone} onChange={(e) => setEditZone(e.target.value)}
                                        Style={'width: 100%; padding: 8px 10px; border: 1px solid #b6b6b6; border-radius: 5px; box-sizing: border-box;'}>
                                        <option value="">Select zone...</option>
                                        {zones.map(z => <option key={z} value={z}>{z}</option>)}
                                    </select>
                                )}
                                {editVisType === 'country' && (
                                    <div>
                                        <div Style={'position: relative; margin-bottom: 10px;'}>
                                            <input type="text" value={editCountrySearch} onChange={(e) => setEditCountrySearch(e.target.value)}
                                                placeholder="Search country..."
                                                Style={'width: 100%; padding: 8px 10px; border: 1px solid #b6b6b6; border-radius: 5px; box-sizing: border-box;'} />
                                            {editCountrySearch.length >= 1 && (
                                                <div Style={'position: absolute; z-index: 10; background: white; border: 1px solid #b6b6b6; border-radius: 5px; max-height: 200px; overflow-y: auto; width: 100%; margin-top: 2px; box-shadow: 0 2px 8px rgba(0,0,0,0.15);'}>
                                                    {countries.filter(c => c.toLowerCase().includes(editCountrySearch.toLowerCase()) && !editCountries.includes(c)).slice(0, 30).map(c => (
                                                        <div key={c}
                                                            onClick={() => { setEditCountries([...editCountries, c]); setEditCountrySearch('') }}
                                                            Style={'padding: 8px 10px; cursor: pointer; border-bottom: 1px solid #eee; font-size: 13px;'}
                                                            onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                            onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}>
                                                            {c}
                                                        </div>
                                                    ))}
                                                    {countries.filter(c => c.toLowerCase().includes(editCountrySearch.toLowerCase()) && !editCountries.includes(c)).length === 0 && <div Style={'padding: 10px; color: #999; text-align: center;'}>No countries found</div>}
                                                </div>
                                            )}
                                        </div>
                                        {editCountries.length > 0 && (
                                            <div Style={'display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 10px;'}>
                                                {editCountries.map(c => (
                                                    <span key={c} Style={'background: #efefef; padding: 4px 8px; border-radius: 12px; font-size: 12px; display: inline-flex; align-items: center; gap: 6px;'}>
                                                        {c}
                                                        <svg onClick={() => setEditCountries(editCountries.filter(x => x !== c))} xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#666" className="bi bi-x" viewBox="0 0 16 16" Style={'cursor: pointer;'}>
                                                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                                        </svg>
                                                    </span>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                )}
                                {(editVisType === 'zone' || editVisType === 'country' || editVisType === 'all') && (
                                    <div Style={'margin-top: 10px;'}>
                                        <button className='submit-button' onClick={saveVisibility} disabled={savingVis}
                                            Style={'font-size: 12px; padding: 6px 16px;'}>
                                            {savingVis ? 'Saving...' : 'Save Visibility'}
                                        </button>
                                    </div>
                                )}
                            </div>
                            {/* Manage Stores (only for JDA visibility) */}
                            {editVisType === 'jda' && (
                            <div Style={'margin-bottom: 15px;'}>
                                <div className='label_text' Style={'margin-bottom: 8px; font-weight: bold;'}>Stores (JDA)</div>
                                <div Style={'position: relative; margin-bottom: 10px;'}>
                                    <div Style={'display: flex; gap: 8px; align-items: center;'}>
                                        <input type="text" value={storeSearch} onChange={(e) => { setStoreSearch(e.target.value); setNewStoreJDA('') }}
                                            placeholder="Search by JDA, name or country..."
                                            Style={'flex: 1; padding: 6px 10px; border: 1px solid #b6b6b6; border-radius: 5px;'} />
                                        <button className='submit-button' onClick={addStore} disabled={!newStoreJDA}
                                            Style={'font-size: 12px; padding: 6px 12px;' + (!newStoreJDA ? ' opacity: 0.5;' : '')}>Add</button>
                                    </div>
                                    {storeSearch.length >= 2 && !newStoreJDA && (
                                        <div Style={'position: absolute; z-index: 10; background: white; border: 1px solid #b6b6b6; border-radius: 5px; max-height: 200px; overflow-y: auto; width: calc(100% - 70px); margin-top: 2px; box-shadow: 0 2px 8px rgba(0,0,0,0.15);'}>
                                            {allStores.filter(s => {
                                                const q = storeSearch.toLowerCase()
                                                const jda = (s.location_code || s.JDA || '').toLowerCase()
                                                const name = (s.location_description || s.Name || '').toLowerCase()
                                                const country = (s.country || s.Country || '').toLowerCase()
                                                return jda.includes(q) || name.includes(q) || country.includes(q)
                                            }).slice(0, 20).map(s => (
                                                <div key={s.location_code || s.JDA}
                                                    onClick={() => { setNewStoreJDA(s.location_code || s.JDA); setStoreSearch(`${s.location_code || s.JDA} - ${s.location_description || s.Name}`) }}
                                                    Style={'padding: 8px 10px; cursor: pointer; border-bottom: 1px solid #eee; font-size: 13px;'}
                                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                    onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}>
                                                    <strong>{s.location_code || s.JDA}</strong> — {s.location_description || s.Name || '-'} <span Style={'color: #999;'}>({s.country || s.Country || '-'}, {s.channel_description || s.Cluster || '-'})</span>
                                                </div>
                                            ))}
                                            {allStores.filter(s => {
                                                const q = storeSearch.toLowerCase()
                                                return (s.location_code || s.JDA || '').toLowerCase().includes(q) || (s.location_description || s.Name || '').toLowerCase().includes(q) || (s.country || s.Country || '').toLowerCase().includes(q)
                                            }).length === 0 && <div Style={'padding: 10px; color: #999; text-align: center;'}>No stores found</div>}
                                        </div>
                                    )}
                                </div>
                                {storesLoading ? (
                                    <div Style={'text-align: center; padding: 10px;'}>Loading...</div>
                                ) : userStores.length > 0 ? (
                                    <div Style={'max-height: 300px; overflow-y: auto;'}>
                                        <table className="responsive-table mt0" Style={'width: 100%;'}>
                                            <thead>
                                                <tr className="table-header">
                                                    <th>JDA</th>
                                                    <th>Name</th>
                                                    <th>Country</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {userStores.map((store) => (
                                                    <tr key={store.jda || store.JDA || store.location_code}>
                                                        <td><div className="mid">{store.jda || store.JDA || store.location_code}</div></td>
                                                        <td><div className="mid">{store.name || store.Name || store.location_description || '-'}</div></td>
                                                        <td><div className="mid">{store.country || store.Country || '-'}</div></td>
                                                        <td>
                                                            <div className="mid">
                                                                <svg onClick={() => removeStore(store.jda || store.JDA || store.location_code)} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red" className="bi bi-trash" viewBox="0 0 16 16" Style={'cursor: pointer;'}>
                                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                                </svg>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className='label_text center' Style={'padding: 10px; color: #999;'}>No stores assigned</div>
                                )}
                            </div>
                            )}
                        </div>
                    </Modal>
                    {/* Create User Modal */}
                    <Modal ariaHideApp={false} isOpen={createModal} onRequestClose={() => setCreateModal(false)} style={largeModalStyles}>
                        <div className='modal_filters_container'>
                            <div>
                                <div className='filter-label-cont' Style={'text-align:center'}>Create New User</div>
                                <svg onClick={() => setCreateModal(false)} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-x close-button" viewBox="0 0 16 16">
                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                </svg>
                            </div>
                            <hr className='separator' />
                            {/* Email */}
                            <div Style={'margin-bottom: 15px;'}>
                                <div className='label_text' Style={'margin-bottom: 5px; font-weight: bold;'}>Email</div>
                                <input type="email" value={newUserEmail} onChange={(e) => checkEmail(e.target.value)} placeholder="user@gucci.com"
                                    Style={'width: 100%; padding: 8px 10px; border: 1px solid ' + (emailExists ? 'red' : '#b6b6b6') + '; border-radius: 5px; box-sizing: border-box;'} />
                                {emailExists && <div Style={'color: red; font-size: 12px; margin-top: 4px;'}>This email already exists</div>}
                                {checkingEmail && <div Style={'color: #666; font-size: 12px; margin-top: 4px;'}>Checking...</div>}
                            </div>
                            {/* Admin checkbox */}
                            <div Style={'margin-bottom: 15px;'}>
                                <div className='label_text' Style={'margin-bottom: 5px; font-weight: bold;'}>Admin</div>
                                <select value={newUserIsAdmin ? 'yes' : 'no'}
                                    onChange={(e) => setNewUserIsAdmin(e.target.value === 'yes')}
                                    Style={'width: 100%; padding: 8px 10px; border: 1px solid #b6b6b6; border-radius: 5px; box-sizing: border-box;'}>
                                    <option value="no">No</option>
                                    <option value="yes">Yes</option>
                                </select>
                            </div>
                            {/* Visibility type */}
                            <div Style={'margin-bottom: 15px;'}>
                                <div className='label_text' Style={'margin-bottom: 8px; font-weight: bold;'}>Visibility</div>
                                <div Style={'display: flex; gap: 15px; margin-bottom: 10px;'}>
                                    <label Style={'cursor: pointer; display: flex; align-items: center; gap: 5px;'}>
                                        <input type="radio" name="visType" value="zone" checked={visibilityType === 'zone'}
                                            onChange={() => setVisibilityType('zone')} Style={'cursor: pointer;'} />
                                        <span className='label_text'>Zone</span>
                                    </label>
                                    <label Style={'cursor: pointer; display: flex; align-items: center; gap: 5px;'}>
                                        <input type="radio" name="visType" value="country" checked={visibilityType === 'country'}
                                            onChange={() => setVisibilityType('country')} Style={'cursor: pointer;'} />
                                        <span className='label_text'>Country</span>
                                    </label>
                                    <label Style={'cursor: pointer; display: flex; align-items: center; gap: 5px;'}>
                                        <input type="radio" name="visType" value="jda" checked={visibilityType === 'jda'}
                                            onChange={() => setVisibilityType('jda')} Style={'cursor: pointer;'} />
                                        <span className='label_text'>JDA</span>
                                    </label>
                                    <label Style={'cursor: pointer; display: flex; align-items: center; gap: 5px;'}>
                                        <input type="radio" name="visType" value="all" checked={visibilityType === 'all'}
                                            onChange={() => setVisibilityType('all')} Style={'cursor: pointer;'} />
                                        <span className='label_text'>All</span>
                                    </label>
                                </div>
                                {visibilityType === 'all' && (
                                    <div className='label_text' Style={'padding: 8px 0; color: #666; font-size: 13px;'}>
                                        The user will have access to all stores.
                                    </div>
                                )}
                                {/* Zone */}
                                {visibilityType === 'zone' && (
                                    <select value={newUserZone} onChange={(e) => setNewUserZone(e.target.value)}
                                        Style={'width: 100%; padding: 8px 10px; border: 1px solid #b6b6b6; border-radius: 5px; box-sizing: border-box;'}>
                                        <option value="">Select zone...</option>
                                        {zones.map(z => <option key={z} value={z}>{z}</option>)}
                                    </select>
                                )}
                                {/* Country multi-select */}
                                {visibilityType === 'country' && (
                                    <div>
                                        <div Style={'position: relative; margin-bottom: 10px;'}>
                                            <input type="text" value={newUserCountrySearch} onChange={(e) => setNewUserCountrySearch(e.target.value)}
                                                placeholder="Search country..."
                                                Style={'width: 100%; padding: 8px 10px; border: 1px solid #b6b6b6; border-radius: 5px; box-sizing: border-box;'} />
                                            {newUserCountrySearch.length >= 1 && (
                                                <div Style={'position: absolute; z-index: 10; background: white; border: 1px solid #b6b6b6; border-radius: 5px; max-height: 200px; overflow-y: auto; width: 100%; margin-top: 2px; box-shadow: 0 2px 8px rgba(0,0,0,0.15);'}>
                                                    {countries.filter(c => c.toLowerCase().includes(newUserCountrySearch.toLowerCase()) && !newUserCountries.includes(c)).slice(0, 30).map(c => (
                                                        <div key={c}
                                                            onClick={() => { setNewUserCountries([...newUserCountries, c]); setNewUserCountrySearch('') }}
                                                            Style={'padding: 8px 10px; cursor: pointer; border-bottom: 1px solid #eee; font-size: 13px;'}
                                                            onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                            onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}>
                                                            {c}
                                                        </div>
                                                    ))}
                                                    {countries.filter(c => c.toLowerCase().includes(newUserCountrySearch.toLowerCase()) && !newUserCountries.includes(c)).length === 0 && <div Style={'padding: 10px; color: #999; text-align: center;'}>No countries found</div>}
                                                </div>
                                            )}
                                        </div>
                                        {newUserCountries.length > 0 && (
                                            <div Style={'display: flex; flex-wrap: wrap; gap: 6px;'}>
                                                {newUserCountries.map(c => (
                                                    <span key={c} Style={'background: #efefef; padding: 4px 8px; border-radius: 12px; font-size: 12px; display: inline-flex; align-items: center; gap: 6px;'}>
                                                        {c}
                                                        <svg onClick={() => setNewUserCountries(newUserCountries.filter(x => x !== c))} xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#666" className="bi bi-x" viewBox="0 0 16 16" Style={'cursor: pointer;'}>
                                                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                                        </svg>
                                                    </span>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                )}
                                {/* JDA multi-select */}
                                {visibilityType === 'jda' && (
                                    <div>
                                        <div Style={'position: relative; margin-bottom: 10px;'}>
                                            <input type="text" value={newUserStoreSearch} onChange={(e) => setNewUserStoreSearch(e.target.value)}
                                                placeholder="Search by JDA, name or country..."
                                                Style={'width: 100%; padding: 8px 10px; border: 1px solid #b6b6b6; border-radius: 5px; box-sizing: border-box;'} />
                                            {newUserStoreSearch.length >= 2 && (
                                                <div Style={'position: absolute; z-index: 10; background: white; border: 1px solid #b6b6b6; border-radius: 5px; max-height: 200px; overflow-y: auto; width: 100%; margin-top: 2px; box-shadow: 0 2px 8px rgba(0,0,0,0.15);'}>
                                                    {allStores.filter(s => {
                                                        const q = newUserStoreSearch.toLowerCase()
                                                        const code = (s.location_code || s.JDA || '').toLowerCase()
                                                        const name = (s.location_description || s.Name || '').toLowerCase()
                                                        const country = (s.country || s.Country || '').toLowerCase()
                                                        const alreadyPicked = newUserJDAs.some(p => p.jda === (s.location_code || s.JDA))
                                                        return !alreadyPicked && (code.includes(q) || name.includes(q) || country.includes(q))
                                                    }).slice(0, 20).map(s => (
                                                        <div key={s.location_code || s.JDA}
                                                            onClick={() => {
                                                                const item = {
                                                                    jda: s.location_code || s.JDA,
                                                                    name: s.location_description || s.Name || '-',
                                                                    country: s.country || s.Country || '-',
                                                                    cluster: s.channel_description || s.Cluster || ''
                                                                }
                                                                setNewUserJDAs([...newUserJDAs, item])
                                                                setNewUserStoreSearch('')
                                                            }}
                                                            Style={'padding: 8px 10px; cursor: pointer; border-bottom: 1px solid #eee; font-size: 13px;'}
                                                            onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                            onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}>
                                                            <strong>{s.location_code || s.JDA}</strong> — {s.location_description || s.Name || '-'} <span Style={'color: #999;'}>({s.country || s.Country || '-'}, {s.channel_description || s.Cluster || '-'})</span>
                                                        </div>
                                                    ))}
                                                    {allStores.filter(s => {
                                                        const q = newUserStoreSearch.toLowerCase()
                                                        const code = (s.location_code || s.JDA || '').toLowerCase()
                                                        const name = (s.location_description || s.Name || '').toLowerCase()
                                                        const country = (s.country || s.Country || '').toLowerCase()
                                                        const alreadyPicked = newUserJDAs.some(p => p.jda === (s.location_code || s.JDA))
                                                        return !alreadyPicked && (code.includes(q) || name.includes(q) || country.includes(q))
                                                    }).length === 0 && <div Style={'padding: 10px; color: #999; text-align: center;'}>No stores found</div>}
                                                </div>
                                            )}
                                        </div>
                                        {newUserJDAs.length > 0 ? (
                                            <div Style={'max-height: 300px; overflow-y: auto;'}>
                                                <table className="responsive-table mt0" Style={'width: 100%;'}>
                                                    <thead>
                                                        <tr className="table-header">
                                                            <th>JDA</th>
                                                            <th>Name</th>
                                                            <th>Country</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {newUserJDAs.map((store) => (
                                                            <tr key={store.jda}>
                                                                <td><div className="mid">{store.jda}</div></td>
                                                                <td><div className="mid">{store.name}</div></td>
                                                                <td><div className="mid">{store.country}</div></td>
                                                                <td>
                                                                    <div className="mid">
                                                                        <svg onClick={() => setNewUserJDAs(newUserJDAs.filter(p => p.jda !== store.jda))} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red" className="bi bi-trash" viewBox="0 0 16 16" Style={'cursor: pointer;'}>
                                                                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                                        </svg>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        ) : (
                                            <div className='label_text center' Style={'padding: 10px; color: #999;'}>No JDA selected</div>
                                        )}
                                    </div>
                                )}
                            </div>
                            {/* Actions */}
                            <div className='flex_center mt-10' Style={'width:100%'}>
                                <button className='cancel-button' onClick={() => setCreateModal(false)}>Cancel</button>
                                <button className='submit-button' onClick={createUser} disabled={creating || emailExists}>
                                    {creating ? 'Creating...' : 'Create User'}
                                </button>
                            </div>
                        </div>
                    </Modal>
                    <ToastContainer stacked />
                </div>
                : <div>
                    <Navbar />
                    <div Style={' height: calc(100vh - 70px);align-content: center;'}>
                        <div className='label_text_bold center ' Style={'font-size:22px'}>Access restricted to super administrators only</div>
                    </div>
                </div>
        ) : ''))
}
